module.exports = ReactDOM;


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 38
// module chunks = 0